import { clocksNow, generateUUID } from '@datadog/browser-core';
import { ActionType as ActionTypeEnum, FrustrationType as FrustrationTypeEnum } from '../../rawRumEvent.types';
import { startEventTracker } from '../eventTracker';
import { isActionChildEvent } from './isActionChildEvent';
export function trackManualActions(lifeCycle, onManualActionCompleted) {
    const actionTracker = startEventTracker(lifeCycle);
    function startManualAction(name, options = {}, startClocks = clocksNow()) {
        var _a;
        const lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
        const startedManualAction = actionTracker.start(lookupKey, startClocks, {
            name,
            ...options,
        }, { isChildEvent: isActionChildEvent });
        lifeCycle.notify(15 /* LifeCycleEventType.ACTION_STARTED */, startedManualAction);
    }
    function stopManualAction(name, options = {}, stopClocks = clocksNow()) {
        var _a;
        const lookupKey = (_a = options.actionKey) !== null && _a !== void 0 ? _a : name;
        const stopped = actionTracker.stop(lookupKey, stopClocks, options);
        if (!stopped) {
            return;
        }
        const frustrationTypes = [];
        if (stopped.counts && stopped.counts.errorCount > 0) {
            frustrationTypes.push(FrustrationTypeEnum.ERROR_CLICK);
        }
        const manualAction = {
            ...stopped,
            type: stopped.type || ActionTypeEnum.CUSTOM,
            frustrationTypes,
        };
        onManualActionCompleted(manualAction);
    }
    function addInstantAction(action) {
        onManualActionCompleted({ id: generateUUID(), frustrationTypes: [], ...action });
    }
    return {
        addAction: addInstantAction,
        startAction: startManualAction,
        stopAction: stopManualAction,
        findActionId: actionTracker.findId,
        stop: actionTracker.stopAll,
    };
}
//# sourceMappingURL=trackManualActions.js.map